<template>
  <div class="fullheight">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item" style="padding-top: 10px">
            <img
              src="../../src/assets/img/cardiff-white-text-only.png"
              id="logo"
              height="28"
              alt="cardiff logo"
            />
          </a>
        </div>
      </div>
    </nav>
    <div class="container is-fluid fullheight" id="appcontainer">
      <div class="columns fullheight is-centered">
        <div class="column" id="app-column">
          <div
            style="max-width: 600px; margin: auto"
            :class="'pushed-pages'"
            v-if="model.business.name == null"
          >
            <a
              class="button is-link is-loading is-large is-fullwidth"
              key="loading"
              >Loading</a
            >
          </div>
          <div style="max-width: 600px; margin: auto; padding-top: 30px" v-else>
            <transition name="slide" mode="out-in">
              <SignatureBreifing
                v-if="pages[index].name == 'SignatureBreifing'"
                key="SignatureBreifing"
                @next="incrementPage"
                :business="model.business.name"
                :pgname="model.pg.name"
              />
              <PersonalInfo
                v-if="pages[index].name == 'PersonalInfo'"
                key="PersonalInfo"
                @next="incrementPage"
              />
              <VerifyOwnership
                v-if="pages[index].name == 'VerifyOwnership'"
                :removeTid="true"
                key="VerifyOwnership"
                @next="incrementPage"
              />
              <Signature
                v-if="pages[index].name == 'Signature'"
                key="Signature"
                @next="incrementPage"
              />
              <Approval
                v-if="pages[index].name == 'Approval'"
                key="Approval"
                @next="incrementPage"
              />
            </transition>
          </div>
        </div>
      </div>
    </div>
    <footer
      class="footer mobile-only"
      style="margin-top: 60px"
      v-if="
        pages[index].name != 'Signature' && pages[index].name != 'BankVerify'
      "
    >
      <div class="content has-text-centered">
        <img
          src="../../src/assets/img/bbb.svg"
          style="margin-left: 15px; max-width: 120px"
          alt="bbb logo"
        />
        <img
          src="../../src/assets/img/ssl.svg"
          style="margin-left: 15px; max-width: 120px; margin-right: 15px"
          alt="SSL logo"
        />
        <p style="font-size: 0.675em; margin-top: 10px">
          © 2025 Cardiff, Inc
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  GetStarted,
  PersonalInfo,
  BankVerify,
  Finicity,
  BusinessInfo,
  FinicityResult,
  VerifyOwnership,
  Signature,
  Approval,
  UploadDoc,
  LoanInfo,
  SignatureBreifing,
} from "@/components/apply/pages";
import { build } from "@/tools/modelBuilder";
import $ from "jquery";
export default {
  name: "SignApp",
  components: {
    PersonalInfo,
    VerifyOwnership,
    Signature,
    SignatureBreifing,
    Approval,
  },
  data() {
    return {
      pages: [
        {
          name: "SignatureBreifing",
          data: {},
        },
        {
          name: "Signature",
          data: {},
        },
        {
          name: "Approval",
          data: {},
        },
      ],
      index: 0,
      demo: false,
      customerId: null,
      model: {
        sfleadid: null,
        oppid: null,
        business: { name: null },
        pg: { name: null },
      },
    };
  },
  computed: {},
  methods: {
    incrementPage: function (pageData) {
      console.log("pageData", pageData);
      this.model = build(this.model, pageData);
      if (pageData.customerId) {
        console.log("we have the customer id ", pageData.customerId);
        this.customerId = pageData.customerId;
      }
      var self = this;
      $.ajax({
        type: "POST",
        url: "/api/signapp/post",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          model: self.model,
          page: self.pages[this.index],
        }),
      })
        .done(function (response) {})
        .fail(function (err) {
          console.log(err.responseText);
          self.invalid = true;
        });
      self.index++;
      window.scrollTo(0, 0);
    },
  },
  mounted: function () {
    // send api call to get pages
    console.log(this.$route.params.code);
    var self = this;
    $.ajax({
      type: "POST",
      url: "/api/signapp/load",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({
        id: self.$route.params.contact,
        oppid: self.$route.params.code,
      }),
    })
      .done(function (response) {
        if (response.businessname) {
          self.model.business.name = response.businessname;
          self.model.pg.name = response.pgname;
          self.model.sfleadid = self.$route.params.contact;
          self.model.oppid = self.$route.params.code;
        }
      })
      .fail(function (err) {
        console.log(err.responseText);
        self.invalid = true;
      });
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar .navbar-brand {
  text-align: center;
  display: block;
  width: 100%;
}

.navbar .navbar-brand > .navbar-item,
.navbar .navbar-brand .navbar-link {
  display: inline-block;
}
@media screen and (min-width: 767px), print {
  .mobile-only {
    display: none;
  }
  #appcontainer {
    margin-left: 0px;
    margin-right: 0px;
  }
  .fullheight {
    height: 100%;
    /* height: 100vh; */
  }
  #app-column {
    padding: 20px 100px;
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  #cardiff-column {
    display: none;
  }
  #app-column {
    min-height: 100vh;
  }
  .fixed-tabs {
    position: fixed;
    z-index: 2;
    background: white;
    top: 0px;
    width: 100%;
    left: 0px;
    transition: all 0.3s;
  }
  .pushed-pages {
    margin-top: 55px !important;
  }
}

#cardiff-column {
  /* background: #f1f1f1; */
  background: linear-gradient(
    90deg,
    rgb(246, 246, 246) 0%,
    rgb(242, 242, 242) 57%,
    rgb(237, 237, 237) 100%
  );
  z-index: 1;
  padding-top: 50px;
  max-width: 280px;
}

#logo {
  /* max-width: 50%; */
  margin: auto;
  display: block;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
}

.next-button {
  margin-top: 10px;
}

.columns {
  margin-left: 0;
  margin-right: 0;
}

.no-margin {
  margin-bottom: 0px !important;
}
</style>
